export const website = (value) => {
	if (!/^(?:http(?:s)?:\/\/)|([\w])(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/.test(value)) {
		return 'Please enter valid website address';
	}
};
